import { Input, OnDestroy, OnInit, Directive } from '@angular/core';

import { Subject, Subscription } from 'rxjs';
import { ReviewFilter } from '../models/review-filter';
import { ReviewService } from '../review.service';
import { REVIEW_DATE_TIME_KEYES } from '../review-helper';
import {takeUntil} from "rxjs/operators"; 

@Directive()
export abstract class ReviewCardComponent implements OnInit, OnDestroy {
  protected reloadSubscription: Subscription;
  protected lastFilter: ReviewFilter;
  protected loaded = false;
  ngUnsubscribe = new Subject<void>();
  protected constructor(protected service: ReviewService) { }
  @Input() name: string;
  @Input() key: string;
  @Input() apiName : string;
  @Input() areaName: string;
  @Input() title: string;
  @Input() triggerKeys: string[];
  @Input()
  reload: (oldFilter: ReviewFilter, newFilter: ReviewFilter) => boolean;
  @Input()
  isList: boolean;
  ngOnInit() {
    this.reloading();
    this.initialize();
  }

  protected initialize(): void { }
  protected abstract loadItems(filter: ReviewFilter): void;
  protected filterChanging(filter: ReviewFilter): void { }

  private reloading() {
    this.service.filter$
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(
      (filter: ReviewFilter) => {
        this.filterChanging(filter);
        if (
          !this.loaded ||
          filter.changedKeys.length > 1 ||
          filter.changedKeys[0] !== this.key
        ) {
          if (
            !this.reload ||
            (this.reload(this.lastFilter, filter) &&
              this.checkTriggerChangedKeys(filter)) ||
            this.checkForceReload(filter)
          ) {
            this.prepareFilterAndLoadItems(filter);
          }
        }

        this.lastFilter = filter;
      }
    );
  }

  private prepareFilterAndLoadItems(filter: ReviewFilter) {
    const filterForLoad = this.prepareFilterForLoading(filter);
    this.loadItems(filterForLoad);
    this.loaded = true;
  }

  protected prepareFilterForLoading(filter: ReviewFilter) {
    const filterForLoad = { ...filter };
    filterForLoad.items = filter.items.filter(i => i.key !== this.key);
    return filterForLoad;
  }

  private checkForceReload(filter: ReviewFilter): boolean {
    return filter.changedKeys.some(c => REVIEW_DATE_TIME_KEYES.indexOf(c) >= 0);
  }

  private checkTriggerChangedKeys(filter: ReviewFilter) {
    return (
      !this.triggerKeys ||
      this.triggerKeys.some(c => filter.changedKeys.indexOf(c) >= 0)
    );
  }

  ngOnDestroy() {
    if(this.ngUnsubscribe)
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
